import { Injectable } from '@angular/core';
import { ApiInterface, ApiQueryParamsDTO } from '../api-interface';
import { ApiService } from '../api.service';
import { Observable } from 'rxjs';
import {
  MovimentoConsultaDTO,
  PageMovimentoConsultaDTO,
} from '../../models/movimentacao.dto';

@Injectable({
  providedIn: 'root',
})
export class MovimentacaoService implements ApiInterface {
  constructor(private apiService: ApiService) {}

  get<T>(
    url: string,
    data?: ApiQueryParamsDTO
  ): Observable<PageMovimentoConsultaDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<PageMovimentoConsultaDTO>(patch);
  }

  getFilter<T>(
    url: string,
    data?: { pessoa_id: number } & ApiQueryParamsDTO
  ): Observable<PageMovimentoConsultaDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const patch = queryParams ? `${url}?${queryParams}` : url;
    return this.apiService.read<PageMovimentoConsultaDTO>(patch);
  }

  getById<T>(url: string, id: string): Observable<MovimentoConsultaDTO> {
    return this.apiService.read<MovimentoConsultaDTO>(`${url}/${id}`);
  }

  post<T>(
    url: string,
    data: MovimentoConsultaDTO
  ): Observable<MovimentoConsultaDTO> {
    return this.apiService.create<MovimentoConsultaDTO>(url, data);
  }

  put<T>(
    url: string,
    data: MovimentoConsultaDTO
  ): Observable<MovimentoConsultaDTO> {
    return this.apiService.update<MovimentoConsultaDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }
}
